interface PageSpinnerProps {
  label?: string
}

export function PageSpinner({ label = "Cargando…" }: PageSpinnerProps) {
  return (
    <div role="status" aria-label={label} className="motion-fade flex min-h-[40vh] items-center justify-center">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent motion-reduce:animate-none"
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  )
}
